import type { CSSProperties } from 'react'
import './ArtworkPreviewSurface.css'

type ArtworkPreviewSurfaceProps = {
  alt: string
  className?: string
  imageClassName?: string
  maxHeight?: number | string
  src: string
}

const previewMaxHeight = (maxHeight: number | string) => (typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight)

const ArtworkPreviewSurface = ({
  alt,
  className = '',
  imageClassName = '',
  maxHeight = '220px',
  src
}: ArtworkPreviewSurfaceProps) => (
  <div
    className={`artwork-preview-surface ${className}`.trim()}
    style={{ '--artwork-preview-max-height': previewMaxHeight(maxHeight) } as CSSProperties}
  >
    <img className={`artwork-preview-surface__image ${imageClassName}`.trim()} src={src} alt={alt} />
  </div>
)

export default ArtworkPreviewSurface
